import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import AddIcon from "@mui/icons-material/Add";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";

import "./payment.css";
import axios from "../../components/Axios";
import AddCredits from "../../components/AddCredits";
import Subscription from "./subscription";
import Invoices from "./invoices";

const CARDS = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
  diners: "DinersClub",
  discover: "Discover",
  jcb: "JCB",
  unionpay: "UnionPay",
  unknown: "Unknown",
};

// Account > Billing: credit and subscription (left), payment methods and invoices (right)
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      credit: 0,
      methods: [],
      default: null,
      subscribed: false,
      add_credit_open: false,
      // bumped after a purchase or a subscription change, to reload the invoices
      rev: 0,
    };
  }

  componentDidMount() {
    this.getItems();
  }

  getItems = async () => {
    this.setState({ loading: true });
    let resp = await axios.get("/user/stripe/payment_methods");
    this.setState({
      loading: false,
      methods: resp.data["payment_methods"],
      credit: resp.data["credit"],
      default: resp.data["default"],
      subscribed: resp.data["subscribed"],
    });
  };

  handleCreditOpen(open) {
    this.setState({ add_credit_open: open });
  }

  paymentSuccess = () => {
    this.getItems();
    this.handleCreditOpen(false);
    this.setState((s) => ({ rev: s.rev + 1 }));
  };

  subscriptionChanged = () => {
    this.getItems();
    this.setState((s) => ({ rev: s.rev + 1 }));
  };

  async deleteItem(item) {
    this.setState({ loading: true });
    await axios.delete("/user/stripe/payment_method/" + item.id);
    this.getItems();
  }

  async setDefault(item) {
    this.setState({ loading: true });
    await axios.get("/user/stripe/payment_method/" + item.id + "/set_default");
    this.getItems();
  }

  render() {
    const { t } = this.props;
    const { loading, methods } = this.state;

    return (
      <>
        <div className="ac-grid">
          <div className="ac-col ac-wplan">
            <section className="ac-card" aria-labelledby="ac-credit-h">
              <div className="ac-head">
                <h2 id="ac-credit-h" className="ac-title">
                  {t("VideoViews Credit")}
                </h2>
                <span className="ac-spacer" />
                <Button
                  className="Button ButtonPrimary ac-btn"
                  startIcon={<AddIcon />}
                  onClick={this.handleCreditOpen.bind(this, true)}
                  disabled={methods.length === 0}
                >
                  {t("Add Credits")}
                </Button>
              </div>
              <div className="ac-body">
                <div className="ac-figure">
                  <img className="ac-mark" src="/img/favicon.png" alt="" />
                  <div style={{ minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "baseline", gap: "6px" }}>
                      <span className="ac-big">{loading ? "-" : this.state.credit.toFixed(2)}</span>
                      <span className="ac-desc">{t("credits")}</span>
                    </div>
                    <p className="ac-help">
                      {t("1 credit provides A.I Analysis")} {t("for 1 hour of video content")}
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <Subscription onChange={this.subscriptionChanged} />
          </div>

          <div className="ac-col ac-wpay">
            <section className="ac-card" aria-labelledby="ac-methods-h">
              <div className="ac-head">
                <h2 id="ac-methods-h" className="ac-title">
                  {t("Payment Methods")}
                </h2>
                {!loading && <span className="ac-badge">{methods.length}</span>}
                <span className="ac-spacer" />
                <Button className="Button ButtonSecondary ac-btn" startIcon={<AddIcon />} onClick={() => this.props.history.push("/account/add_payment")}>
                  {t("Add payment method")}
                </Button>
              </div>
              {loading && methods.length === 0 && <CircularProgress size={24} />}
              {!loading && methods.length === 0 && <div className="ac-empty">{t("No payment methods yet")}</div>}
              {methods.map((item) => {
                const isDefault = this.state.default === item.id;
                const month = (item.card.exp_month < 10 ? "0" : "") + item.card.exp_month;
                return (
                  <div key={"payment-" + item.id} className="ac-item ac-method">
                    <img className="ac-brand" src={"/img/payments/" + item.card.brand + ".png"} alt={CARDS[item.card.brand] || item.card.brand} />
                    <div style={{ minWidth: 0, display: "flex", flexDirection: "column", gap: "1px" }}>
                      <div style={{ minWidth: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                        <span className="ac-name">
                          {CARDS[item.card.brand] || item.card.brand} •••• {item.card.last4}
                        </span>
                        {isDefault && <span className="ac-badge">{t("Default")}</span>}
                      </div>
                      <span className="ac-meta">{t("Expires {{date}}", { date: month + "/" + item.card.exp_year })}</span>
                    </div>
                    <div className="ac-actions">
                      {!isDefault && (
                        <button type="button" className="ac-link" onClick={this.setDefault.bind(this, item)} disabled={loading}>
                          {t("Set Default")}
                        </button>
                      )}
                      <button type="button" className="ac-link" onClick={this.deleteItem.bind(this, item)} disabled={loading}>
                        {t("Remove")}
                      </button>
                    </div>
                  </div>
                );
              })}
            </section>

            <Invoices key={this.state.rev} />
          </div>
        </div>
        <AddCredits
          onClose={this.handleCreditOpen.bind(this, false)}
          open={this.state.add_credit_open}
          subscribed={this.state.subscribed}
          onSuccess={this.paymentSuccess}
          onRefresh={this.subscriptionChanged}
        />
      </>
    );
  }
}

export default withTranslation()(withRouter(Index));
